import { NgModule } from '@angular/core';

import { CisBaseRoutingModule } from './cis-base-routing.module';
import { CisBaseComponent } from './cis-base.component';
import { SharedModule } from 'cbc-shared-lib';

import { MenuComponent } from './pages/menu/menu.component';
import { SgBaseSharedModule } from '../../sg-base/sg-base-shared/sg-base-shared.module';
import { Sgkz001dComponent } from './pages/sgkz001d/sgkz001d.component';
import { TopSideMenuComponent } from './components/top-side-menu/top-side-menu.component';
import { ChildSideMenuComponent } from './components/child-side-menu/child-side-menu.component';

/**
 * 一般機能モジュール
 * @export
 * @class CisBaseModule
 */
@NgModule({
  declarations: [
    CisBaseComponent,
    Sgkz001dComponent,
    MenuComponent,
    TopSideMenuComponent,
    ChildSideMenuComponent,
  ],
  imports: [
    CisBaseRoutingModule,
    SharedModule,
    SgBaseSharedModule,
  ],
  exports: [
    MenuComponent,
  ]
})
export class CisCommonModule { }
